import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useRef, useEffect } from 'react';
import '../../../utils/assertion.esm.js';
import '../../../utils/ssr.esm.js';
import '../../../utils/number.esm.js';
import '../../../utils/array.esm.js';
import '../../../utils/breakpoint.esm.js';
import '../../../utils/context.esm.js';
import '../../../utils/dom.esm.js';
import '../../../utils/tabbable.esm.js';
import '../../../utils/dom-query.esm.js';
import '../../../utils/logger.esm.js';
import '../../../utils/focus.esm.js';
import '../../../utils/function.esm.js';
import '../../../utils/keydown.esm.js';
import '../../../utils/lazy.esm.js';
import '../../../utils/object.esm.js';
import { mergeRefs } from '../../../utils/react-helpers.esm.js';
import '../../../utils/style-props.esm.js';
import '../../../utils/tailwind.esm.js';
import Box from '../../Box/index.esm.js';
import Card from '../../Card/index.esm.js';
import Flex from '../../Flex/index.esm.js';
import '../../../hooks/use-safe-layout-effects.esm.js';
import '../../../hooks/use-callback-ref.esm.js';
import '../../../hooks/use-clickable.esm.js';
import '../../../hooks/use-clipboard.esm.js';
import '../../../hooks/use-combobox-dropdown-style.esm.js';
import '../../../hooks/use-combobox-style.esm.js';
import '../../../hooks/use-controllable.esm.js';
import '../../../hooks/use-local-storage.esm.js';
import '../../../hooks/use-media.esm.js';
import '../../../hooks/use-prefers-dark-mode.esm.js';
import '../../../hooks/use-dark-mode.esm.js';
import '../../../hooks/use-force-update.esm.js';
import '../../../hooks/use-descendant.esm.js';
import '../../../hooks/use-id.esm.js';
import '../../../hooks/use-previous.esm.js';
import '../../../hooks/use-disclosure.esm.js';
import { useDropdownStyle } from '../../../hooks/use-dropdown-style.esm.js';
import '../../../hooks/use-latest-ref.esm.js';
import '../../../hooks/use-event-listener.esm.js';
import '../../../hooks/use-event-listener-v2.esm.js';
import '../../../hooks/use-update-effect.esm.js';
import '../../../hooks/use-focus-on-hide.esm.js';
import '../../../hooks/use-pointer-event.esm.js';
import '../../../hooks/use-focus-on-pointerdown.esm.js';
import '../../../hooks/use-focus-on-show.esm.js';
import '../../../hooks/use-fork-ref.esm.js';
import '../../../hooks/use-hints.esm.js';
import '../../../hooks/use-input-style.esm.js';
import '../../../hooks/use-key-press.esm.js';
import '../../../hooks/use-lock-body-scroll.esm.js';
import '../../../hooks/use-platform.esm.js';
import '../../../hooks/use-shortcut.esm.js';
import Portal from '../../Portal/index.esm.js';
import Text from '../../Text/index.esm.js';
import { useComboboxContext } from '../context.esm.js';
import OptionItem from './OptionItem.esm.js';

var Dropdown = function Dropdown() {
  var _useComboboxContext = useComboboxContext(),
      open = _useComboboxContext.open,
      popper = _useComboboxContext.popper,
      width = _useComboboxContext.width,
      getMenuProps = _useComboboxContext.getMenuProps,
      items = _useComboboxContext.items,
      highlightedIndex = _useComboboxContext.highlightedIndex,
      inputValue = _useComboboxContext.inputValue;

  var shown = open && items.length > 0;
  var styles = useDropdownStyle({
    open: shown
  });
  var dropdownRef = useRef(null);

  var groupItems = function groupItems() {
    var groupResult = items.reduce(function (result, item) {
      var label = item.group || '';

      if (result[label]) {
        // eslint-disable-next-line no-param-reassign
        result[label].items = [].concat(result[label].items, [item]);
      } else {
        // eslint-disable-next-line no-param-reassign
        result[label] = {
          label: label,
          items: [item]
        };
      }

      return result;
    }, {});
    var index = 0;
    Object.values(groupResult).forEach(function (group) {
      return group.items.forEach(function (item) {
        // eslint-disable-next-line no-param-reassign
        item.index = index;
        index += 1;
      });
    });
    return Object.values(groupResult);
  };

  useEffect(function () {
    if (!dropdownRef.current || highlightedIndex === -1) return;
    var dropdownNode = dropdownRef.current;
    var item = dropdownNode.querySelector("[data-index=\"" + highlightedIndex + "\"]");
    var dropdownHeight = dropdownNode.clientHeight || 0;
    var itemHeight = (item == null ? void 0 : item.clientHeight) || 0;
    var dropdownClientBottom = dropdownNode.getBoundingClientRect().bottom;
    var itemClientBottom = (item == null ? void 0 : item.getBoundingClientRect().bottom) || 0;
    var diff = itemClientBottom - dropdownClientBottom;

    if (diff > 0) {
      dropdownNode.scrollTo({
        top: diff + dropdownNode.scrollTop
      });
    } else if (dropdownHeight + diff < itemHeight) {
      dropdownNode.scrollTo({
        top: dropdownNode.scrollTop + dropdownHeight + diff - itemHeight
      });
    }
  }, [highlightedIndex]);
  useEffect(function () {
    if (!dropdownRef.current || !open) return;
    dropdownRef.current.scrollTo({
      top: 0
    });
  }, [open, inputValue]);
  return React__default.createElement(Portal, null, React__default.createElement(Card, _extends({}, styles, {
    style: _extends({}, popper.style, {
      width: width
    }),
    ref: mergeRefs(popper.ref, dropdownRef)
  }), React__default.createElement(Box, _extends({
    as: "ul"
  }, getMenuProps()), open ? groupItems().map(function (group) {
    return React__default.createElement(Box, {
      as: "li",
      key: group.label
    }, group.label && React__default.createElement(Flex, {
      justifyContent: "justify-between",
      alignItems: "items-center"
    }, React__default.createElement(Text, {
      padding: ['px-2', 'py-1'],
      fontWeight: "font-medium",
      textColor: "text-gray-400",
      letterSpacing: "tracking-wide"
    }, group.label), React__default.createElement(Text, {
      backgroundColor: "bg-gray-200",
      borderRadius: "rounded-full",
      padding: "px-2",
      fontSize: "text-sm"
    }, group.items.length)), React__default.createElement(Box, {
      as: "ul"
    }, group.items.map(function (item) {
      return React__default.createElement(OptionItem, {
        index: item.index || 0,
        key: item.index,
        width: "w-full",
        item: item
      });
    })));
  }) : null)));
};

export default Dropdown;
//# sourceMappingURL=Dropdown.esm.js.map
